import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=48e0f1f2&scoped=true"
import script from "./clientDetail.vue?vue&type=script&lang=js"
export * from "./clientDetail.vue?vue&type=script&lang=js"
import style0 from "./clientDetail.vue?vue&type=style&index=0&id=48e0f1f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e0f1f2",
  null
  
)

export default component.exports